import {
	isEpicHierarchyLevel,
	isBaseHierarchyLevel,
	isSubtaskHierarchyLevel,
} from '@atlassian/jira-issue-type-hierarchies/src/index.tsx';
import { getProjectAvatarUrl } from '@atlassian/jira-project-settings-apps-common/src/avatar-service/avatar-normalizer.tsx';
import type { IssueTypeNavigationItem, RawIssueType } from '../../types.tsx';

type IssueTypeNavigationItemsCategories = {
	topLevel: IssueTypeNavigationItem[];
	baseLevel: IssueTypeNavigationItem[];
	bottomLevel: IssueTypeNavigationItem[];
};

const JSD_IS_EMAIL_REQUEST_TYPE = 'jsd.simplified.issue.type.isEmail';

const getIssueTypeNavigationItemsLevels = (issueTypes: RawIssueType[]) =>
	issueTypes.reduce(
		(acc: IssueTypeNavigationItemsCategories, issueType) => {
			const { id, avatarId, name, hierarchyLevel, properties, operations } = issueType;

			const issueTypeNavigationItem = {
				id,
				name,
				avatarId,
				operations,
				icon: getProjectAvatarUrl(avatarId),
			};

			if (
				isEpicHierarchyLevel(hierarchyLevel) ||
				(properties && properties[JSD_IS_EMAIL_REQUEST_TYPE])
			) {
				acc.topLevel.push(issueTypeNavigationItem);
			} else if (isBaseHierarchyLevel(hierarchyLevel)) {
				acc.baseLevel.push(issueTypeNavigationItem);
			} else if (isSubtaskHierarchyLevel(hierarchyLevel)) {
				acc.bottomLevel.push(issueTypeNavigationItem);
			}

			return acc;
		},
		{
			topLevel: [],
			baseLevel: [],
			bottomLevel: [],
		},
	);

const getIsIssueTypeLimitReached = (limitPerProject: number | null, numberOfIssueTypes: number) =>
	limitPerProject !== null && limitPerProject > 0 && numberOfIssueTypes >= limitPerProject;

export { getIssueTypeNavigationItemsLevels, getIsIssueTypeLimitReached };

export type { IssueTypeNavigationItemsCategories };
